import styles from './styles.module.scss';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import i18n from 'i18next';
import userServices from '@/api/userServices';
import { styled } from '@mui/material/styles';
import Cookies from 'js-cookie';
import { getDefaultLanguage, getSupportedLanguages } from '@/utils/languageConfig';

const StyledItem = styled(MenuItem)({
  '&.Mui-selected': {
    backgroundColor: 'transparent !important',
    '&:hover': { backgroundColor: 'var(--other-bg) !important' },
  },
});

const LANGUAGE_LABELS: Record<string, string> = {
  fr: 'general.french',
  en: 'general.english',
  pt: 'general.portuguese',
};

export const LanguageSelector = () => {
  const { t } = useTranslation();
  const [language, setLanguage] = useState<string>('');

  const changeLocalization = (lang: string) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
    i18n.changeLanguage(lang);
    Cookies.get('accessToken') && userServices.updateUserLanguage(lang);
  };

  useEffect(() => {
    const currentlang = localStorage.getItem('language') ?? getDefaultLanguage();
    setLanguage(currentlang);
    i18n.changeLanguage(currentlang);
  }, []);

  const supportedLanguages = getSupportedLanguages();

  return (
    <FormControl size='small'>
      <Select
        IconComponent={KeyboardArrowDownIcon}
        value={language}
        onChange={(event: any) => changeLocalization(event.target.value)}
        className={styles.language}
        onOpen={() => document.getElementById('header')?.classList.add('pr-1.5')}
        onClose={() => document.getElementById('header')?.classList.remove('pr-1.5')}
      >
        {supportedLanguages.map(lang => (
          <StyledItem key={lang} value={lang}>
            {t(LANGUAGE_LABELS[lang] || lang)}
          </StyledItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelector;
